/* istanbul ignore file */
import {
  WysiwygInputPasteArtifactDecorator,
  WysiwygInputPasteArtifactDecoratorProps,
} from 'domain/shared/artifact/input';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { WysiwygInput, WysiwygInputProps } from 'framework/form';

const TimelineNoteWysiwygInput = ({
  artifactsSource,
  isRiskService,
  ...props
}: WysiwygInputProps & Omit<WysiwygInputPasteArtifactDecoratorProps, 'children'>) => {
  return (
    <WysiwygInputPasteArtifactDecorator
      artifactsSource={artifactsSource}
      artifactTypeId={ARTIFACT_ID.NOTE_ATTACHMENT}
      isRiskService={isRiskService}
    >
      <WysiwygInput {...props} />
    </WysiwygInputPasteArtifactDecorator>
  );
};

export default TimelineNoteWysiwygInput;
